<template>
  <div class="main-container">
    <!-- Author: Bhushan
      Date: 1/1/2021
    -->
   <!--  <breadcrumb :list="breadcrumbList" />  -->
   <!--  <under-construction></under-construction> -->
    <div class="margintop-16" />
    <tl-header type="h1">Income Tax Declaration</tl-header>
    <div class=" lineheight">

        <div>
          <div class="mask">
            <div class="img-close" @click="closeIcon">
              <img src="@/assets/cross.svg" />
            </div>
            <div class="img-user">
              <img src="@/assets/user.svg" class="oval" />
            </div>          
            <div class="month">
              <div class="employee-fullname">{{` ${employeeObj.first_name == null ? "" : employeeObj.first_name} ${employeeObj.last_name == null ? "" : employeeObj.last_name} `}} </div>
              <div class="employee-code"> {{ `${employeeObj.code == null ? "" : employeeObj.code}`}} </div>
              <div class="salary-perks">Salary and Perks:</div>
              <div class="salary-ctc"> ₹ {{empCtc}}</div>
              <!-- <div class="salary-ctc">{{`${salary.ctc}`}}</div> -->
            </div>
            <!-- <div class="close-card"><span> x </span></div> -->
          </div>
      </div>

      </div>
      
      <div class="document-new-block" v-if="!planList.length" >
        <!-- <div class="bg-gray" v-if="!itEnableValue">
          <img class="warning-img" src="@/assets/warning.svg" alt />
          <span class="investment-alert-message">Income Tax Declaration window will be open between {{ `${this.startDate}`}} to {{ `${this.endDate}`}} every Month.</span>
        </div> -->
        <img src="@/assets/undraw-notify-88-a-4.svg" alt />
        <div class="text"><span class="bold-text">No investment plans to show yet!</span>
         <div class="click-on-Add-New-t"> <span >Click on 'Add New' to create first investment plan</span> </div>
        
        <div>
          <div class="add-new-icon-document" @click="selecetTaxRegimePlan">
            <img src="@/assets/circle-cross.svg" alt />
            <span class="add-new">Add New</span>
          </div>
        <!-- <button class="add-btn-small" @click="nothingnow" >
          <img src="@/assets/group-5.svg" class="resize"><span class="add-new">Add New</span>
        </button> -->
        </div>
        </div>
      </div>
      
      <div class="investment-plans-block" v-if="planList.length>0">
            <!-- <div class="bg-gray" v-if="!itEnableValue">
              <img class="warning-img" src="@/assets/warning.svg" alt />
              <span class="investment-alert-message">Income Tax Declaration window will be open between {{ `${this.startDate}`}} to {{ `${this.endDate}`}} every Month.</span>
            </div> -->
            <br>
            <h4 class="investment-plans-title">Investment Plans</h4>
            <div class="bg-gray" v-if="planTest==false">
              <img class="warning-img" src="@/assets/warning.svg" alt />
              <span class="investment-alert-message">IT declaration for this employee will not be considered in tax calculations until you submit one of the plans below</span>
            </div>
            <!-- Section 2 -->
        <div class="container-fluid">
          <!-- <div class="row my-4">
            <div class="col-4 marginbottom-5p" v-for="(planList, index) in planList" :key="index">
              <div class="componentName">
                <div class="c-title" @click="updatePlan(planList)">{{planList.plan_name}}
                  <br>
                   <div class="plan-submit" v-if="planList.is_plan_active==false">Submit</div>
                
                </div>
                  <div class="c-icon"><img src="@/assets/star_normal.svg" /></div> 
               </div>
            </div>
          </div> -->
            
          <div class="dflex">
            <div class="flexChild" v-for="(planList, index) in planList" :key="index">
              <div class="block-deductions" @click="updatePlan(planList)">
                <div class="row">
                  <div class="col-9">
                      <h4 class="block-deductions-title" >{{planList.plan_name}}</h4>
                  </div>
                  <div class="col-3 deduction-img">
                    <img class="icon-i" src="@/assets/group-2.png" alt />
                  </div>
                </div>
              </div>
              <div class="below-block">
                  <div class="row">
                    <div class="col-12">
                      <div class="plan-submit" v-if="planList.is_plan_active==false" @click="makeActivePlan(planList)">Submit</div>
                      <div class="plan-submit" v-if="planList.is_plan_active==true" >Active</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>  
            <!--this is add new section in plan list-->
          <div class="row my-4">
            <div>
              <!-- <div class="block-deductions-dash">
                <div class="center-block-add-new"  @click="selecetTaxRegimePlan">
                  <img class="block-add-new-icon" src="@/assets/circle-cross.svg" alt />
                  <span class="add-new">Add New</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <!-- end section 2 -->
      </div>
    <footer>
      <bottom-action-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="cancel" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>

    <!-- Another Popup Message show click on Save paln button -->
    <div class="modal" v-if="showConfirmationPopup">
      <div class="modal-content" ref="modalBox">
        <div class="heading_new animated fadeInRight">
          Enter Your Plan Name
        </div>
        <input 
          type="text" 
          name="planName" 
          autofocus="autofocus" 
          autocomplete="off" 
          class="inputField"
          v-model="instance.plan_name"
          placeholder="For Ex. Plan A(Old Regime), Plan B(New Regime) etc">
        <div class="popup-btns">
          <btn-grp>
            <popup-btn
              text="Cancel"
              type="secondary"
              @click="cancelEvent"
          />
            <popup-btn text="Save" type="primary" @click="selecetTaxRegimePlan" />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End here -->

  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      employeeObj: null,
      showConfirmationPopup: false,
      // personal: {
      //   first_name: null,
      //   last_name: null,
      //   code: null,
      // },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: []
      },
      empCtc:null,
      instance:{
        plan_name:"",
        is_plan_active:false,
        employee_id: ""
      },
      planList:[],
      planTest:false,
      itEnableValue: false,
      startDate: "",
      endDate: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
    }),
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
         }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifHR() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
  },

  mounted() {
    this.salaryTableData = [];
    this.fetchRecord();
    this.getItPlan();
    //this.getPlanId();
    //this.selecetTaxRegimePlan();
    this.itStatusEnable();
  },
  activated() {
    //this.fetchAllSalaryStructureData();
    this.salaryTableData = [];
    //this.setRecordData();  
    this.fetchRecord();
    this.getItPlan();
    //this.selecetTaxRegimePlan();
    //this.getPlanId();
    this.itStatusEnable();
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
        act_set_plan:"dashboard/payroll/incometax/setPlanName",
        act_get_plan:"dashboard/payroll/incometax/getPlan",
        act_active_plan:"dashboard/payroll/incometax/activatePlan",
        //act_get_plan_id:"dashboard/payroll/incometax/getPlanId"
        act_get_it_enable:"dashboard/payroll/incometax/getItEnable"
    }),
    async fetchRecord() {
        let empId = this.$route.query.id;
        this.instance.employee_id = empId;
        let payload ={
          empId:empId,
          empLeId:this.le_id
        }
        let res = await this.act_fetchEmpById(payload);
        this.employeeObj = res.data.payload.data;
        //this.empData = employeeObj;
        this.empCtc=this.employeeObj.EmployeeSalarySetting[0].ctc
        //console.log("Data...",this.employeeObj);
        
        //this.setPersonalData(employeeObj.personal);
        //this.setsalryData(employeeObj.salary);

    },

    addNewInvestmentPlan() {
      this.showConfirmationPopup = true;
    },
    updatePlan(item){
      //le_id=ee4c2d69-19e8-4e33-b0af-27d56548b39a  &employee_id=0001e8a6-daa8-4b84-aff5-1caade8029a1& financial_year=2019  & it_plan_id=b837a59b-efd8-4dff-ba1b-d0992533f5c7
      ////console.log(item);
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxdeclarationplan`,
        query: { it_plan_id:item.id ,employee_id:item.employee_id}
      });
        
    },
    async makeActivePlan(rec){

      //console.log("plan data",rec);
      let payload={
        plan_id:"",
        plan_name:"",
        is_plan_active:false,
        employee_id:"",
      }
         payload.plan_id=rec.id;
         payload.plan_name=rec.plan_name;
         payload.is_plan_active=true;
         payload.employee_id=this.instance.employee_id;
        if(rec.is_plan_active===false){
            let res= await this.act_active_plan(payload);
            //console.log("res after making plan active",res);
            this.getItPlan();

        }else{
                    //console.log("plan is already active")
   
        }
      

    },

   async selecetTaxRegimePlan() {
     let planNumber = this.planList.length + 1;
     this.instance.plan_name = `IT Plan ${planNumber}`
      let res = await this.act_set_plan(this.instance)
     //console.log("checking response",res);
      this.showConfirmationPopup = false;
      this.fetchRecord();
      this.getItPlan();
     
    },
    async getItPlan() {
      let res = await this.act_get_plan(this.instance.employee_id)
      this.planList=res.data.payload;
      for (var i = 0; i < this.planList.length; i++) {
        if(this.planList[i].is_plan_active=== true)
          this.planTest=true;
      }
    },

    // async getPlanId() {
    //   let res = await this.act_get_plan_id(this.it_plan_id)
    //   //this.planId=res.data.payload;
    //   //console.log("PLAN ID", res);
    // },
    
    cancel() {
      if(this.ifHR || this.ifEmployee) {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/overview`,
        });
      } else {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax`
        });
      this.showConfirmationPopup = false;
      } 
    },
    
    closeIcon() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax`
      });
      this.showConfirmationPopup = false;
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationPopup = false;
    },

    async itStatusEnable() {
      let res = await this.act_get_it_enable({le_id:this.le_id});
      let time = new Date();
      let day = time.getDate();
      ////console.log("Time", day);
      
      this.itEnableValue = res.data.payload.data.ITDeclarationSetting.ITEnable;
      this.startDate = res.data.payload.data.ITDeclarationSetting.startDate;
      this.endDate = res.data.payload.data.ITDeclarationSetting.endDate;
      day <= this.endDate ? this.itEnableValue = true : this.itEnableValue = false;
     // //console.log("IT Enable", this.itEnableValue,this.startDate, this.endDate);
      
    }

  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  // width: 258.5px;
  width:290px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center{
  margin: 500px ;
}
.resize{
  margin-left: 100px;
}
.bold-text{
    width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new{
    width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 55px;
  height: 55px;
  border-radius: 41px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.dflex{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}

.img-user {
    margin-right: 10px;
    position: absolute;
}

.month {
    position: relative;
    margin-left: 32%;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  font-size: 12px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
    position: absolute;
    cursor: pointer;
    color: #5d409f;
    right: 10px;
    top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

.investment-plans-block {
  margin-top: 13%;
}

.investment-plans-title {
  font-size: 16px;
  margin: 20px 0 10px 0;
}

.bg-gray {
  background-color: #f2f2f2;
  padding: 10px 20px;
  height: 60px;
  margin: 20px 0;
}

.investment-alert-message {
  font-size: 14px;
  font-weight: 600;
}

.warning-img {
  height: 25px;
  width: 25px;
  margin-right: 15px;
  transform: translate(5px, 5px);
}

.block-deductions {
  width: 360px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px 8px 0px 0px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  }

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(-10px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.below-block {
    margin-top: -1px;
    text-align: center;
    border: 1px solid #efefef;
    padding: 15px;
    width: 360px;
    border-radius: 0px 0px 10px 10px;
}

.plan-submit {
  font-family: Montserrat;
  //margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color:#5d409f;
  cursor: pointer;
  //border: 1px solid #efefef;
  width: 100%;
  
}

.block-deductions-dash {
  width: 360px;
  height: 200px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: 2px dashed #34c0be;
  background-color: #ffffff;
  cursor: pointer;  
}

.center-block-add-new {
  padding: 70px 0;
  text-align: center;
}

.block-add-new-icon {
  transform: translate(0px, 5px);
}

.img-close {
  position: absolute;
  transform: translate(238px, -10px);
  cursor: pointer;
}


// Modal start css

  .modal {
    display: block;
    position: fixed;
    z-index: 6;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // background-color: rgba(0, 0, 0, 0.3);
    background: rgba(0, 0, 0, 0.60);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(10px);
  }

  /* Modal Content */

  .modal-content {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 30%;
    // height: 191px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    opacity: 0;
    padding: 30px 30px 30px 30px;
    -webkit-animation-name: showPopup;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
    // -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-fill-mode: forwards;

    .success-icon {
      // margin-bottom: 40px;
    }

    .success-text {
      font-size: $font-size-l1;
      font-weight: 600;
      // margin-bottom: auto;
      margin-left: 12px;
      color: #6e6e6e;
    }

    .message-text {
      font-size: $font-size-l1;
      margin-bottom: 20px;
      line-height: 25px;
      animation-delay: 0.7s;
      animation-name: fadeInRight;
      -webkit-animation-name: fadeInRight;
    }
    .btn-confirm-delete{
      display: flex;
      align-items: center;
      *:nth-child(n){
        margin-right: 20px;
      }
    }
    .warning {
      margin-bottom: 16px;
      text-align: center;
      height: 24px;
      width: 24px;
    }
    .btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: $color-primary;
      color: $color-white;
    }
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 2px;
      color: #34c0be;
    }

    .close-btn {
      position: relative;
      transform: scale(2);
      left: 230px;
      bottom: 20px;
      cursor: pointer;
    }
  }
  .success-img {
    position: relative;
    height: 24px;
    width: 24px;
    &.animated {
      animation-name: pulse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      -webkit-animation-name: pulse;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 3s;
    }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showc {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 1; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
@-webkit-keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}

@keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}
}
@-webkit-keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}

}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  
}

.heading_new {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

input.inputField {
  border: 2px solid #dcdcdc;
  width: 100%;
  padding: 15px;
  margin: 15px 0px;
  border-radius: 5px;
  font-size: 13px;
}
</style>
